import { useQuery } from "@tanstack/react-query";
import taskTemplateService from "../api/taskTemplateService";

export const useTaskTemplate = (templateId) => {
  const { getTaskTemplate } = taskTemplateService();

  return useQuery({
    queryKey: ["get-task-template", templateId],
    queryFn: async () => {
      const res = await getTaskTemplate(templateId);
      return res.data;
    },
    enabled: !!templateId,
  });
};

export const useTaskTemplates = (taskTypeId) => {
  const { getTaskTemplates } = taskTemplateService();

  return useQuery({
    queryKey: ["get-task-templates", taskTypeId],
    queryFn: async () => {
      const res = await getTaskTemplates(taskTypeId);
      return res.data;
    },
    enabled: !!taskTypeId,
  });
};


export const useAllTaskTemplates = () => {
  const { getAllTaskTemplates } = taskTemplateService();

  return useQuery({
    queryKey: ["get-all-task-templates"],
    queryFn: async () => {
      const res = await getAllTaskTemplates();
      return res.data;
    }
  });
};
